var utils = require('./utils');
var board = require('./board');

var app = {
    init: function() {
        this.bindEvent();
    },
    bindEvent: function() {
        var that = this;
        $(document).on('click', '#submit_message', function () {
            if ($(this).hasClass('disabled')) {
                return;
            }
            board.submitMessage(function() {
                // 重写提交成功事件
                $('.allow-bd').html(
                    '<div class="allow-suc">' +
                    '    <span class="h"><i class="ico ico-suc"></i></span>'  +
                    '    <p class="b">提交成功</p>' +
                    '    <p class="f">我们将在3-5个工作日内与您联系</p>' +
                    '</div>'
                );
            });
        });
        // $('body').append('<iframe src="http://cms3.17173.com/content/release/article.html?act=edit&type=0&isReleased=true&id=10147946_1_1000126234&contentType=1" frameborder="0" height="800px" width="100%"></iframe>');

        Passport.on(Passport.EVENTS.logoutSuccess, function () {
            location.href = '/site/signin';
        });
        if (!Passport.isLoggedIn()) {
            location.href = '/site/signin';
        }
    }
}

$(function () {
    app.init();
})